import { ReactNode, createContext, useMemo, useState } from "react";

import moment from "moment-timezone";

export const TimeZoneContext = createContext<any>(null);

interface TimeZoneProviderProps {
  children: ReactNode;
}

const TimeZoneProvider = ({ children }: TimeZoneProviderProps) => {
  const getSystemTimezone = (): string => moment.tz.guess(true);

  const initialTimeZone = () => {
    const detectedTimeZone = getSystemTimezone();

    return detectedTimeZone;
  };

  const [currentTimeZone, setCurrentTimeZone] = useState(initialTimeZone());

  const changeTimeZone = (timeZone: string) => {
    setCurrentTimeZone(timeZone);
  };

  const revertToSystemTimeZone = () => {
    setCurrentTimeZone(getSystemTimezone());
  };

  const timeZoneContextProviderValue = useMemo(() => {
    return {
      currentTimeZone,
      systemTimeZone: getSystemTimezone(),
      changeTimeZone,
      getSystemTimezone,
      revertToSystemTimeZone,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTimeZone]);

  return (
    <TimeZoneContext.Provider value={timeZoneContextProviderValue}>
      {children}
    </TimeZoneContext.Provider>
  );
};

export default TimeZoneProvider;
